module.exports = __webpack_public_path__ + "static/logo-82c52045d6c1934fccdf0641d1e84fe4.png";